import { render, staticRenderFns } from "./tableChart.vue?vue&type=template&id=38c072d4&scoped=true"
import script from "./tableChart.vue?vue&type=script&lang=js"
export * from "./tableChart.vue?vue&type=script&lang=js"
import style0 from "./tableChart.vue?vue&type=style&index=0&id=38c072d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c072d4",
  null
  
)

export default component.exports